export default __webpack_public_path__ + "c25d59518afd6b8806d2b4860e5a65ab.svg";